import { render, staticRenderFns } from "./customerLvyueTableLq.vue?vue&type=template&id=c0ed1906"
import script from "./customerLvyueTableLq.vue?vue&type=script&lang=js"
export * from "./customerLvyueTableLq.vue?vue&type=script&lang=js"
import style0 from "./customerLvyueTableLq.vue?vue&type=style&index=0&id=c0ed1906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports